module.exports = require("@seddi/three/addons/loaders/EXRLoader.js");